export default __webpack_public_path__ + "static/media/checkbox-blank-circle.7dc8a88e.svg";